import { render, staticRenderFns } from "./AreYouShureRemovingAttraction.vue?vue&type=template&id=ddecc8c6&scoped=true"
import script from "./AreYouShureRemovingAttraction.vue?vue&type=script&lang=js"
export * from "./AreYouShureRemovingAttraction.vue?vue&type=script&lang=js"
import style0 from "./AreYouShureRemovingAttraction.vue?vue&type=style&index=0&id=ddecc8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddecc8c6",
  null
  
)

export default component.exports